import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SettingService } from './setting.service';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  constructor(private http: HttpClient, private settingsService: SettingService) { }
  
  pocaeUsuario = this.settingsService.settings.usuario;

  error: any;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }) 
  }

  getInfo(json) {
    return this.http.post(this.pocaeUsuario + "/usuario/info", JSON.stringify(json), this.httpOptions)
    .pipe(retry(4), catchError(this.error));
  }
}
